export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7521.fb2bf215.jpg";